// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "../constants";
// import { Verify2FASuccess, Verify2FAError } from "../actions/auth2FAActions";
import { request } from "src/helpers/request";
import { Verify2FAError, Verify2FASuccess } from "../actions/authActions";
import { isDevelopment } from "src/module/helpers";
import { isWebView } from "src/services/firebase";

/**
 * Worker Saga: proses kirim OTP ke server
 */
function* verify2FAWorker(action) {
    try {

        // console.log(action)

        const otp = action.otp?.otp;
        const challenge = localStorage.getItem("authChallenge");

        if (!otp || !challenge) {
            throw new Error(
                !challenge
                    ? "Sesi verifikasi 2FA tidak ditemukan. Silakan login kembali."
                    : "Kode OTP wajib diisi."
            );
        }

        // Request ke backend
        const response = yield call(request, "post", "/auth/verify-2fa", {
            otp,
            remember: action?.otp?.remember,
            challenge,
            device_type: isWebView ? 'android' : "browser",
        });

        const data = response?.data;

        if (!data?.token) {
            throw new Error("Token autentikasi tidak diterima dari server.");
        }
        // Challenge hanya digunakan sekali.



        if (response?.data?.token) {
            console.log("Tekan kene token baru")
            localStorage.setItem('authToken', JSON.stringify(response?.data))
        }

        localStorage.removeItem("authChallenge");

        // Jika sukses: kirim action ke redux
        yield put(Verify2FASuccess(response?.data));



        // OPTIONAL:
        // Jika backend memberikan token baru:


        yield put({ type: ActionTypes.SETTING_STATE })

        // yield put({
        //     type: ActionTypes.PROFILE_SET_SUCCESS,
        //     payload: data,
        // })

    } catch (error) {
        if (isDevelopment) {
            console.log(error)
        }
        /* 
              return yield put({
                            type: ActionTypes.USER_AUTH_FAILURE,
                            redirect: '/login',
                        });
                        
        */
        yield put(Verify2FAError(error?.response?.data || error.message));
    }
}

/**
 * Watcher Saga
 * 
 * 
 */
export default function* watchVerify2FA() {
    yield takeLatest(ActionTypes.VERIFY_2FA, verify2FAWorker);
}
